import { CURRENT_USER, USER_PREFERENCE } from "constants/AuthConstant";
export const getPermissions = () => {
  const currentUser = getLoggedInUser();
  //const currentUser = ["view-testDirectories", "view-neworders",  "view-pending-discrepancies", "approve-discrepancy", "decline-discrepancy"];
  return currentUser?.permissions;
};

export const hasPermission = (component_permission) => {
  const user_permissions = getPermissions();
  const current_user_permission =
    user_permissions !== undefined
      ? user_permissions.map((item) => {
          return item.permission_name;
        })
      : [];
  return current_user_permission.length <= 0
    ? false
    : current_user_permission.includes(component_permission, 0);
};

export const getCurrentRoleName = () => {
  return getLoggedInUser().name;
};

export const getCurrentRole = () => {
  return getLoggedInUser()?.role ?? "";
};

export function getLoggedInUser() {
  // console.log(localStorage.getItem(CURRENT_USER));
  return JSON.parse(localStorage.getItem(CURRENT_USER));
}

export const doesThisUserIsAgency = () => {
  let currentUser = getLoggedInUser();
  return currentUser["client_company"] !== null ? true : false;
};

export const doesThisAgencyIsAllowedForCredit = () => {
  let currentUser = getLoggedInUser();
  if (currentUser["client_company"] !== null) {
    return currentUser["client_company"]["allowed_for_credit"] === "1"
      ? true
      : false;
  } else {
    return false;
  }
};

export const doesThisUserIsAdvancareUser = () => {
  if (!getLoggedInUser()) {
    return 0;
  } else {
    return getLoggedInUser()["advancare_user"] === 1 ? 1 : 0;
  }
};

export const doesThisUserNotadvancareUser = () => {
  return doesThisUserIsAdvancareUser() ? 0 : 1;
};

export const getUserPreference = () => {
  return JSON.parse(localStorage.getItem(USER_PREFERENCE) ?? []);
};

export const getUserLocation = () => {
  return getLoggedInUser()["cashier_location"] ?? "";
};

export const getCurrentUserName = () => {
  return getLoggedInUser()["name"] ?? "";
};

//could be redendant be used to prevent confilct on neworder
export const getAgencyName = () => {
  return getLoggedInUser()["name"] ?? "";
};

export const getClientCompanyId = () => {
  return getLoggedInUser()["client_company_id"];
};

export const getCurrentUserId = () => {
  return getLoggedInUser()?.["id"];
};

export const getCurrentUserClientCompanyId = () => {
  return getLoggedInUser()?.["client_company_id"];
};

export const getClientCompanyName = () => {
  return getLoggedInUser()?.["client_company"]["name"] ?? "";
};

export const doesThisUserIsGuestUser = () => {
  return getLoggedInUser() ? getLoggedInUser()["user_type"] === "guest" : false;
};

export const doesThisUserIsSrd = () => {
  return getLoggedInUser() ? getLoggedInUser()["user_type"] === "srd" : false;
};

export const doesThisUserIsCashier = () => {
  return getLoggedInUser()["user_type"] === "cashier";
};

export const doesThisUserIsPhlebotomy = () => {
  return getLoggedInUser()["user_type"] === "phlebotomy";
};

export const doesThisUserIsLabTechnician = () => {
  return getLoggedInUser()["user_type"] === "lab";
};

export const doesThisUserIsFinance = () => {
  return getLoggedInUser()["user_type"] === "finance";
};

export const doesThisUserIsAdmin = () => {
  return getLoggedInUser()["user_type"] === "admin";
};

export const doesThisUserIsDoctor = () => {
  return getLoggedInUser()?.["user_type"] === "doctor";
};

export const doesThisUserIsCustomerFeedbackOfficer = () => {
  return getLoggedInUser()?.["user_type"] === "customer_feedback_officer";
};

export const getCurrentUserEmail = () => {
  return getLoggedInUser()["email"];
};

export const getCashierCode = () => {
  return getLoggedInUser()["cashier_code"];
};
